import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import get from 'lodash/get';
import { bookingJourneyType } from 'common/constants/booking';
import OpportunityDetails from './opportunity';
import OrderDetails from './order';

const ReconciliationDetails = () => {
  const location = useLocation();

  const { record = {}, bookingJourney } = location?.state || {};

  const booking = useMemo(() => {
    if (record?.completedXbooking) {
      return {
        id: record.id,
        referenceId: get(record, 'completedXbooking.referenceId'),
        ...record,
      };
    } else {
      return record;
    }
  }, [record]);

  return (
    <Choose>
      <When condition={bookingJourney === bookingJourneyType.MANUAL}>
        <OpportunityDetails booking={booking} />
      </When>
      <Otherwise>
        <OrderDetails booking={booking} bookingJourney={bookingJourney} />
      </Otherwise>
    </Choose>
  );
};

ReconciliationDetails.propTypes = {
  match: PropTypes.object,
};

ReconciliationDetails.defaultProps = {
  match: null,
};

export default ReconciliationDetails;
